// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"38d90d0b","453":"68a0de9e","482":"6f616065"}[chunkId] + ".chunk.js";
};